import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { site } from "@/data/site";

export default function Datenschutz() {
  return (
    <div className="min-h-screen bg-background text-white py-24 px-6 md:px-12">
      <div className="max-w-3xl mx-auto">
        <Link to="/" data-testid="datenschutz-back" className="inline-flex items-center gap-2 text-white/60 hover:text-white transition-colors mb-10 text-sm">
          <ArrowLeft className="w-4 h-4" /> Zurück zur Startseite
        </Link>
        <h1 className="font-heading font-extrabold text-4xl md:text-5xl tracking-tight mb-10">Datenschutzerklärung</h1>

        <div className="space-y-8 text-white/70 leading-relaxed text-sm">
          <section>
            <h2 className="font-heading font-semibold text-lg text-white mb-2">1. Verantwortlicher</h2>
            <p>
              Tesla-Verleih-Frankfurt · Mobilitätsberatung<br />
              {site.street}, {site.city}<br />
              Telefon: {site.phoneDisplay} · E-Mail: {site.email}
            </p>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-lg text-white mb-2">2. Erhebung von Daten über das Kontaktformular</h2>
            <p>
              Wenn Sie uns über das Kontaktformular eine Anfrage senden, verarbeiten wir die von Ihnen
              angegebenen Daten (Name, E-Mail-Adresse, ggf. Telefonnummer, Betreff und Nachricht)
              ausschließlich zur Bearbeitung Ihrer Anfrage. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b
              bzw. lit. f DSGVO.
            </p>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-lg text-white mb-2">3. Google Maps</h2>
            <p>
              Zur Darstellung unseres Standorts binden wir Google Maps ein. Anbieter ist Google Ireland
              Limited. Beim Aufruf der Karte kann Ihre IP-Adresse an Google übermittelt werden. Weitere
              Informationen finden Sie in der Datenschutzerklärung von Google.
            </p>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-lg text-white mb-2">4. Speicherdauer</h2>
            <p>
              Wir speichern Ihre Daten nur so lange, wie dies für die Bearbeitung Ihrer Anfrage bzw.
              zur Erfüllung gesetzlicher Aufbewahrungspflichten erforderlich ist.
            </p>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-lg text-white mb-2">5. Ihre Rechte</h2>
            <p>
              Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung,
              Datenübertragbarkeit sowie ein Widerspruchsrecht. Zudem steht Ihnen ein Beschwerderecht
              bei einer Datenschutz-Aufsichtsbehörde zu.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
